'use strict';
module.exports = function invertVertically(layoutNodes) {
	const result = {};
	Object.keys(layoutNodes).forEach(key => {
		const bubbleOffset = (layoutNodes[key].bubble &&   layoutNodes[key].bubble.y) || 0;
		result[key] = Object.assign({}, layoutNodes[key], {y: -1 * layoutNodes[key].y - bubbleOffset - layoutNodes[key].height });
	});
	return result;
};
